import { OrderStatus } from "./orderStatus";

export type OrderPayment = "pix" | "credit_card";

export type QueryResultStatus = "success" | "unavailable" | "not_performed";

export type CardBrand = "mastercard" | "visa";

export type OrderCard = {
	brand: CardBrand;
	holder: string;
	maskedNumber: string;
	expiration: string;
};

export type OrderHistoryStatus =
	| "order_placed"
	| "payment_pending"
	| "payment_paid"
	| "payment_canceled"
	| "query_success"
	| "query_unavailable"
	| "query_emailed";

export type OrderHistoryEvent = {
	status: OrderHistoryStatus;
	date: string;
	description?: string;
};

export type OrderRow = {
	id: string;
	orderNumber: string;
	date: string;
	client: string;
	email: string;
	document: string;
	clientPhone: string;
	clientAddress: string;
	clientSince: string;
	status: OrderStatus;
	queryType: string;
	plate: string;
	queryCode: string;
	queryResultStatus: QueryResultStatus;
	value: number;
	payment: OrderPayment;
	queryQuantity: number;
	pixKey?: string;
	card?: OrderCard;
	history: OrderHistoryEvent[];
};

export const paymentLabel: Record<OrderPayment, string> = {
	pix: "PIX",
	credit_card: "Cartão de Crédito",
};

export const queryResultStatusLabel: Record<QueryResultStatus, string> = {
	success: "Concluída",
	unavailable: "Sistema Indisponível",
	not_performed: "Não Realizada",
};

export const queryResultMessage: Record<QueryResultStatus, string> = {
	success: "Consulta realizada com sucesso",
	unavailable: "Sistema Indisponível",
	not_performed: "Consulta não realizada",
};

export type OrderHistoryStage = "order" | "payment" | "query" | "email";

export const orderHistoryStage: Record<OrderHistoryStatus, OrderHistoryStage> =
	{
		order_placed: "order",
		payment_pending: "payment",
		payment_paid: "payment",
		payment_canceled: "payment",
		query_success: "query",
		query_unavailable: "query",
		query_emailed: "email",
	};

export const orderHistoryStageSource: Record<OrderHistoryStage, string> = {
	order: "Gerenciador do Pedido",
	payment: "Gateway de Pagamento",
	query: "Gerenciador do Pedido",
	email: "Gerenciador do Pedido",
};

export const orderHistoryStatusLabel: Record<OrderHistoryStatus, string> = {
	order_placed: "Pedido Realizado",
	payment_pending: "Aguardando",
	payment_paid: "Pago",
	payment_canceled: "Cancelado",
	query_success: "Consulta Realizada com Sucesso",
	query_unavailable: "Sistema Indisponível",
	query_emailed: "Consulta Enviada por E-mail",
};
